/**
 * Art geometry helpers. The implementation lives in core (`packages/core/src/content/art/geom.ts`) so
 * lesson figures (core content) and client-only art (cast, world maps) share one toolkit.
 */
import { artGeom } from '@sketchling/core';

export type Pt = artGeom.Pt;
export type Taper = artGeom.Taper;
export const { parsePath, samplePath, taperedStroke, ellipse, rot, poly, mirrorX, shift, mix, scallop, blob, open, scale, rotate } = artGeom;
